export default "__VITE_ASSET__ebeff622__"